import { render } from "./message-thinking.vue?vue&type=template&id=a21e3adc&scoped=true&ts=true"
import script from "./message-thinking.vue?vue&type=script&lang=ts"
export * from "./message-thinking.vue?vue&type=script&lang=ts"

import "./message-thinking.vue?vue&type=style&index=0&id=a21e3adc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21e3adc"]])

export default __exports__